export default "__VITE_ASSET__e0c4f3d9__"